import { useBannerMessagesQuery } from "@services/messages/queries";
import { EnefitConsultationBanner } from "./components/EnefitConsultationBanner/EnefitConsultationBanner";

export const ElectricityLeads: React.FC = () => {
  const { data: bannerData } = useBannerMessagesQuery();

  if (
    !bannerData?.some(
      (banner) => banner.bannerType === "enefitElectricityLeads",
    )
  ) {
    return null;
  }

  return (
    <div className="px-4 md:px-0">
      <EnefitConsultationBanner />
    </div>
  );
};
